import { Component, input, output } from "@angular/core";

export interface FilterOption {
  id: string;
  label: string;
  selected: boolean;
  disabled?: boolean;
}

@Component({
  selector: "app-filter-section",
  templateUrl: "./filter-section.component.html",
})
export class FilterSectionComponent {
  title = input.required<string>();
  options = input<FilterOption[]>([]);
  showAll = input<boolean>(true);
  exclusiveSelection = input<boolean>(false); // For radio-button behavior like sort
  parentAllSelected = input<boolean>(false); // Whether parent "All" checkbox is selected
  isMobile = input<boolean>(false); // Controls checkbox appearance (shadow and selected state)

  optionChange = output<{ option: FilterOption; checked: boolean }>();
  allChange = output<boolean>();

  get allSelected(): boolean {
    return this.options().every((option) => option.selected || option.disabled);
  }

  onAllChange(checked: boolean): void {
    this.allChange.emit(checked);
  }

  onOptionChange(option: FilterOption, checked: boolean): void {
    this.optionChange.emit({ option, checked });
  }
}
